<template>
    <div style="background-color: #f7f8fa">
        <van-nav-bar style="background-color: #42b983">
            <template #title>
                <span v-if="organ && 1===organ.need_show_name" style="color: #ffffff">{{ organ.name }}</span>
                <span v-else style="color: #ffffff">安全及特种作业模拟考试</span>
            </template>
        </van-nav-bar>

        <current-subject></current-subject>

        <br>

        <van-grid :column-num="3" :gutter="10">
            <van-grid-item icon="orders-o" text="顺序练习" to="/exercise?pattern=1"/>
            <van-grid-item icon="description" text="专项学习" to="/exercise?pattern=2"/>
            <van-grid-item icon="todo-list-o" text="模拟考试" to="/exercise?pattern=5"/>
            <van-grid-item icon="failure" text="错题练习" to="/exercise?pattern=3"/>
            <van-grid-item icon="search" text="题库搜索" to="/topics"/>
            <van-grid-item icon="underway-o" text="考试复卷" url="/learns"/>
        </van-grid>

        <br>

        <van-cell-group>
            <van-cell is-link to="/buy">
                <template #title>科目充值</template>
                <template #label>充值科目，或者替别人充值</template>
            </van-cell>
            <van-cell is-link to="/courses?category=1">
                <template #title>
                    课程学习(理论)
                    <van-tag v-if="progress.status>=0" type="danger">学习进度{{progress.progress}}</van-tag>
                </template>
                <template #label>
                    在线学习理论课程
                </template>
            </van-cell>
            <van-cell is-link to="/courses?category=2">
              <template #title>
                课程学习(实操)
              </template>
              <template #label>
                在线学习实操课程
              </template>
            </van-cell>
            <van-cell is-link to="/my">
                <template #title>个人中心</template>
                <template #label>学习情况，清理缓存，了解自己的充值科目等</template>
            </van-cell>
            <van-cell is-link to="/common_problem">
                <template #title>常见问题</template>
                <template #label>常见的一些问题及解答</template>
            </van-cell>
        </van-cell-group>

    </div>
</template>


<script>
    import CurrentSubject from "@/components/CurrentSubject.vue"

    export default {
        components: {
            CurrentSubject
        },
        data() {
            return {
                progress: {},
                organ:{
                  name:"安全及特种作业模拟考试",
                  need_show_name:0
                }
            };
        },
        created() {
            let token = window.localStorage.getItem('token');
            if (!token) {
                this.$router.push('/login');
            }
            this.getProgress();
            this.getUserOrgan();
        },
        methods: {
            getProgress() {
                this.$http.get("/wechat/course/progress").then(res => {
                    if (200 === res.data.code) {
                        this.progress = res.data.data
                    }
                }).catch(err => {
                  console.log("my error",err)
                  if (err.message==="Request failed with status code 401" ) {
                    // 401 清除token信息并跳转到登录页面
                    window.localStorage.setItem('token', '');
                    // router.replace({path: '/login'});
                    window.location.href = "/login"
                  }
                });
            },
          getUserOrgan() {
            this.$http.get("/wechat/user/organ").then(res => {
              if (200 === res.data.code) {
                this.organ = res.data.data
              }
            }).catch(err => {
              console.log("my error",err)
              if (err.message==="Request failed with status code 401" ) {
                // 401 清除token信息并跳转到登录页面
                window.localStorage.setItem('token', '');
                // router.replace({path: '/login'});
                window.location.href = "/login"
              }
            });
          }

        }
    }
</script>

